<template>
  <div class="form-group">
    <label class="custom-label"
      :for="label.toLowerCase().replace(' ', '-')" v-text="label + (required ? ' *' : '')"
    />
    <multiselect
      :value="value"
      :options="options"
      :label="selectLabel"
      track-by="id"
      :placeholder="`Select a ${this.label}`"
      :allow-empty="! required"
      deselect-label=""
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
  export default {
    props: {
      label: null,
      options: null,
      value: null,
      required: {
        default: false,
      },
      selectLabel: {
        default: 'name',
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/CustomSelectSingle.vue